module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--1-0e3b97c3077201a2c51c442b2ff81af6.jpg";